(function() { 'use strict';

    RouteChange.$inject = ['$rootScope'];
    angular.module('mso.registration')
        .config(['$routeProvider', '$translateProvider', '$translatePartialLoaderProvider', Config], Config)
        .run(RouteChange);

    function Config($routeProvider, $translateProvider, $translatePartialLoaderProvider) {
        var routeResolvers = {
            user: {
                referenceData :["$route","ReferenceDataService", function($route, ReferenceDataService){
                    var currentView = $route.current.$$route.originalPath.replace(/\//, '');
                    return ReferenceDataService.getReferenceDataForView(currentView);
                }]},
            admin: {
                auth: function(){
                    return true;
                }}};

        $routeProvider
            .when('/register', {
                template: require('/app/modules/registration/pages/register/register.html').default,
                controller: 'RegisterCtrl',
                controllerAs: 'vm',
                resolve: routeResolvers.user
            })
            .when('/register-success', {
                template: require('/app/modules/registration/pages/register-success/register-success.html').default,
                controller: 'RegisterSuccessCtrl',
                controllerAs: 'vm',
                resolve: routeResolvers.user
            })
            .when('/register-complete/:tokenId', {
                template: require('/app/modules/registration/pages/register-complete/register-complete.html').default,
                controller: 'RegisterCompleteCtrl',
                controllerAs: 'vm',
                resolve: routeResolvers.user
            })
            .when('/register-complete-success', {
                template: require('/app/modules/registration/pages/register-complete-success/register-complete-success.html').default,
                controller: 'RegisterCompleteSuccessCtrl',
                controllerAs: 'vm',
                resolve: routeResolvers.user
            })
            .when('/register-complete-expired', {
                template: require('/app/modules/registration/pages/register-complete-expired/register-complete-expired.html').default,
                controller: 'RegisterCompleteExpiredCtrl',
                controllerAs: 'vm',
                resolve: routeResolvers.user
            })
            .when('/register-complete-deactivated', {
                template: require('/app/modules/registration/pages/register-complete-deactivated/register-complete-deactivated.html').default,
                controller: 'RegisterCompleteDeactivatedCtrl',
                controllerAs: 'vm',
                resolve: routeResolvers.user
            })
            .otherwise({
                redirectTo: '/register'
            });

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translatePartialLoaderProvider.addPart('languages');
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'languages/{lang}/common.lang.txt'
        });
        $translateProvider.preferredLanguage('en-GB');
        $translateProvider.useLoaderCache(true);
    }

    function RouteChange ($rootScope){
        $rootScope.$on('$routeChangeError', function(event, current, previous, rejection){
        });
    }

    angular.module('mso.registration').constant('Config', {
        debug: true,
        apiBaseHref : '/pm-self-management/api/msov1',
        configApiBaseHref : '/pm-self-management',
        // for registration, "find address" is exposed via locally hosted API operations to enable anon access
        addressesApiHref : '/pm-self-management/addresssearch/v1/api',
        umBaseApiHref : '/um-self-management/api/msov1',
        umBaseApiHrefV2 : '/um-self-management/api/v2'
    });
})();
